import axios from '@/lib/axios';
import { useQuery } from '@tanstack/react-query';
import { Notification } from '@/hooks/api/models';

/**
 * 2050. 通知一覧
 * [GET] /workspaces/:identifier/notifications
 */
type Props = {
  identifier: string;
  refetchInterval?: number;
};

const notifications = (props: Props): Promise<Notification[]> => {
  return axios.get(`/api/workspaces/${props.identifier}/notifications`);
};

export const useNotifications = (props: Props) => {
  return useQuery({
    queryKey: ['workspaces', props.identifier, 'notifications'],
    queryFn: () => notifications(props),
    refetchInterval: props.refetchInterval != null ? props.refetchInterval : false,
  });
};
